module.exports = __webpack_public_path__ + "static/media/halyk.3032ef90.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment/kz_pay/halyk.svg
// module id = 885
// module chunks = 7